import { Cart } from '~/types/commercetools';

export const getStoreKey = (cart: Maybe<Readonly<Partial<Cart>>>) => (cart?.store?.key);
